/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { PropsWithChildren, MouseEvent as ReactMouseEvent } from 'react'

import styled, { css } from 'styled-components'

import { ThemeUnits } from '../../types/theme'

type Props = PropsWithChildren<{
  borderRadius?: number | keyof ThemeUnits['borderRadius']
  className?: string
  onClick?: (e: ReactMouseEvent<HTMLElement, MouseEvent>) => void
}>

const CardContainer = ({ borderRadius = 'medium', children, className, onClick }: Props) => {
  return (
    <StyledCard $borderRadius={borderRadius} className={className} onClick={onClick}>
      {children}
    </StyledCard>
  )
}

export default CardContainer

const StyledCard = styled.section<{
  $borderRadius: Required<Props['borderRadius']>
  onClick: Props['onClick']
}>`
  ${({ theme, $borderRadius, onClick }) => css`
    background-color: ${theme.colors.bg};
    border: solid 1px ${theme.colors.gray200};
    border-radius: ${(typeof $borderRadius === 'string' &&
      theme.units.borderRadius[$borderRadius]) ||
    (typeof $borderRadius === 'number' ? `${$borderRadius}px` : undefined)};
    box-shadow: ${theme.shadows.card};
    cursor: ${!!onClick ? 'pointer' : 'default'}
  `}
`
